import data from "../../../../../src/Pagehead/Pagehead.docs.json";
import * as React from 'react';
export default {
  data,
  React
};